import {TextBox} from 'devextreme-react/text-box';
import React, {useState} from 'react';
import './FAQList.scss';
import FAQCard from './FAQCard';

export default function FAQList(props: { questionsAndAnswers: { id: number; Q: string; A: string; }[] }) {

	const [searchString, setSearchString] = useState('')
	const matchSearch = (faq: { id: number; Q: string; A: string; }) =>
		searchString ? faq.Q.toLowerCase().includes(searchString.toLowerCase()) || faq.A.toLowerCase().includes(searchString.toLowerCase()) : true

	return (
		<React.Fragment>

			<div className={'faq-list-title'}>Frequently Asked Questions</div>

			<TextBox className={'search-faq'} placeholder={'What can we help you with?'}
				valueChangeEvent="keyup blur" onValueChange={setSearchString} />

			<div className="faq-list" >
				{props.questionsAndAnswers.filter(matchSearch).length === 0
					? <p>No match for "{searchString}"</p> : props.questionsAndAnswers.filter(matchSearch).map(qa => { return <FAQCard key={qa.id} faq={qa} /> })}
			</div>

		</React.Fragment>
	)
} 
